import { ArrowDownRight, Download } from "lucide-react";
import { ContactButton } from "../components/ContactButton";
import { FadeIn } from "../components/FadeIn";
import { Magnet } from "../components/Magnet";
import { SignalDiagram } from "../components/SignalDiagram";
import { navigation, profile, resumeDownloadName, resumeHref } from "../content/portfolio";

export function HeroSection() {
  return (
    <section
      id="hero"
      aria-labelledby="hero-heading"
      className="hero-section relative flex min-h-[620px] flex-col overflow-x-clip bg-ink"
    >
      <div className="signal-stripe" aria-hidden="true">
        <span />
        <span />
      </div>

      <FadeIn
        as="nav"
        aria-label="主要导航"
        delay={0}
        y={-18}
        className="hero-nav relative z-30 flex items-center justify-between gap-5 px-5 pt-7 sm:px-8 sm:pt-8 md:px-10"
      >
        <a href="#hero" className="hero-mark" aria-label="返回首页">
          <span>CM</span>
          <span>QA / DEV</span>
        </a>
        <div className="hero-nav-links">
          {navigation.map((item) => (
            <a key={item.href} href={item.href} className="hero-nav-link">
              <span>{item.label}</span>
              <small>
                {item.label === "About"
                  ? "关于"
                  : item.label === "Skills"
                    ? "能力"
                    : item.label === "Experience"
                      ? "经历"
                      : item.label === "Projects"
                        ? "项目"
                        : "联系"}
              </small>
            </a>
          ))}
        </div>
      </FadeIn>

      <div
        id="hero-content"
        tabIndex={-1}
        className="hero-main relative z-10 grid flex-1 items-center gap-8 px-5 pb-8 pt-10 sm:px-8 md:grid-cols-[minmax(0,1fr)_minmax(360px,0.9fr)] md:gap-10 md:px-10 md:pb-10 md:pt-4"
      >
        <div className="hero-copy">
          <FadeIn as="h1" id="hero-heading" delay={0.2} y={34} className="hero-heading">
            <span>{profile.name}</span>
            <span>{profile.role}</span>
          </FadeIn>
          <FadeIn as="p" delay={0.34} y={20} className="hero-value">
            {profile.value}
          </FadeIn>
          <FadeIn as="p" delay={0.42} y={18} className="hero-seeking">
            求职方向：{profile.seeking}
          </FadeIn>
          <FadeIn delay={0.52} y={18} className="hero-actions">
            <ContactButton
              href="#projects"
              icon={<ArrowDownRight className="h-4 w-4" aria-hidden="true" />}
            >
              查看项目
            </ContactButton>
            <a
              href={resumeHref}
              download={resumeDownloadName}
              className="secondary-button inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-mist/60 px-5 py-3 text-sm font-semibold tracking-wide text-mist transition-colors duration-200 hover:bg-mist/10 sm:px-7 sm:text-base"
            >
              <Download className="h-4 w-4" aria-hidden="true" />
              下载简历
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} y={28} className="hero-signal-wrap">
          <Magnet padding={110} strength={5}>
            <SignalDiagram />
          </Magnet>
        </FadeIn>
      </div>

      <div className="hero-bottom relative z-20 flex items-end justify-between gap-5 px-5 pb-6 sm:px-8 sm:pb-8 md:px-10 md:pb-10">
        <FadeIn delay={0.48} y={16} className="hero-bottom-note">
          <span>从风险开始，到明确结论结束。</span>
        </FadeIn>
        <FadeIn delay={0.58} y={16} className="hero-bottom-meta">
          <span>{profile.experience}</span>
          <span>可协作交付</span>
        </FadeIn>
      </div>
    </section>
  );
}
